import React from "react";

const FloatingTextarea = ({
  label = "Enter text",
  value,
  onChange,
  name,
  rows = 3,
  placeholder = " ",
  required = false,
  disabled = false,
}) => {
  return (
    <div className="form-floating mb-3">
      <textarea
        className="form-control"
        placeholder={placeholder}
        id={name}
        name={name}
        style={{ height: `${rows * 25}px` }}
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
      />
      <label htmlFor={name}>{label}</label>
    </div>
  );
};

export default FloatingTextarea;